import { Route } from '@/router/types'

export const patientMgmtRoutes: Route[] = [
  {
    path: '/patients',
    name: '#patients',
    component: () => import('@/legacy/pages/PatientsPage.vue'),
    meta: {
      title: 'Members',
      permissionCheck: null,
    },
  },
  {
    path: '/patients/create',
    name: '#addPatient',
    component: () => import('@/legacy/pages/AddPatient/AddPatient.vue'),
    meta: {
      title: 'Create Member',
      permissionCheck: null,
    },
  },
]
